import CASL from '@/utils/constants/casl'

export default {
  path: 'survey',
  children: [
    {
      path: '',
      name: 'survey.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.SURVEY
      },
      component: () => import('./list/SurveyListPage.vue')
    }
  ]
}
